import { render } from "./message.vue?vue&type=template&id=2b662880"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"

import "./message.vue?vue&type=style&index=0&id=2b662880&lang=scss"

import exportComponent from "D:\\Development\\vue\\okraina.sbs.monitor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__